<template>
  <div style="text-align: center;">
    <p style="margin-top: 15px;">No builder has been selected. Please select a builder prior to selecting a plan name to proceed.</p>
    <div style="text-align: center;">
      <button type="button" @click="closeModal" class="btn btn-fill btn-info">
        Close
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    methods: {
      closeModal () {
        this.$emit('close')
      }
    }
  }
</script>
